
const BID_PLACEMENT = 1;
const REQUEST_ACCEPTANCE = 2;
const REQUEST_ASSIGNMENT =  3;
const REQUEST_TEXTING = 4;
const SERVICE_LOCATION = 5;
const BUSINESS_PROFILE = 6;
const BUSINESS_REVIEWS = 7;
const SUBSCRIPTIONS_SEARCH = 8;
const TRIAL_SUBSCRIPTIONS = 9;
const FAILED_COMMISSION_PAYMENTS = 10;
const FAILED_SUBSCRIPTION_PAYMENTS = 11;
const ACCOUNTS_DASHBOARD = 12;
const ADD_SELLER_SUBSCRIPTION = 13;
const REQUEST_DASHBOARD = 14;
const FILL_RATE = 15;
const WEEKLY_FILL_RATE = 16;
const CHURN_CANDIDATES = 17;
const SOURCING = 18;
const EDIT_REQUEST = 19;
const SEE_ALL_REQUESTS = 20;
const BID_PLACEMENT_SEARCH = 21;
const SEND_SMS = 22;
const DELETE_SMS = 23;
const MESSENGER = 24
const EDIT_BUYER_NUMBER = 25
const SHOW_PROS_LINK = 26
const ADD_REQUEST_NOTES = 27
const COMMISSION_PAYMENT_OVERRIDE = 28
const SOURCING_EMAIL = 29
const CALL_SELLER = 30;
const CALL_BUYER = 31;
const CALL_RECORDING_DOWNLOAD = 32;
const CALL_ANYONE = 33;
const COMMISSION_PAYMENTS = 34;
const SBR_ACCESS_TOKEN = 35;
const EDIT_NEARBY_PROS_DATA = 36;
const SAVE_SMS_IMAGE_TO_SBR = 37;
const SHOW_HIDDEN_OUTGOING_SMS = 38;
const SET_SBR_CONFIRMATION_PRICE = 39;
const SHOW_IN_TRIAL_NEARBY_PROS_TAB = 40;
const SHOW_COMMISSION_ONLY_NEARBY_PROS_TAB = 41; 
const SHOW_CANCELLED_NEARBY_PROS_TAB = 42;
const SHOW_PAYMENT_PLANS = 43;
const IMPERSONATE_SELLER = 44;
const IMPERSONATE_BUYER = 45;
const RADIUS_CHECK = 46;
const ACTUAL_COMMISSION_REVENUE = 47;
const SET_SELLER_PWD = 48;
const SELLER_LIST_BY_ACCEPTING_JOB = 49;
const SELLER_CATEGORY_RADIUS = 50;
const SAAS_METRICS = 51;
const LEAD_PAYMENT_FAILED = 52;

module.exports = {
    BID_PLACEMENT,
    REQUEST_ACCEPTANCE,
    REQUEST_ASSIGNMENT,
    REQUEST_TEXTING,
    SERVICE_LOCATION,
    BUSINESS_PROFILE,
    BUSINESS_REVIEWS,
    SUBSCRIPTIONS_SEARCH,
    TRIAL_SUBSCRIPTIONS,
    FAILED_COMMISSION_PAYMENTS,
    FAILED_SUBSCRIPTION_PAYMENTS,
    ACCOUNTS_DASHBOARD,
    ADD_SELLER_SUBSCRIPTION,
    REQUEST_DASHBOARD,
    FILL_RATE,
    WEEKLY_FILL_RATE,
    CHURN_CANDIDATES,
    SOURCING,
    EDIT_REQUEST,
    SEE_ALL_REQUESTS,
    BID_PLACEMENT_SEARCH,
    SEND_SMS,
    DELETE_SMS,
    MESSENGER,
    EDIT_BUYER_NUMBER,
    SHOW_PROS_LINK,
    ADD_REQUEST_NOTES,
    COMMISSION_PAYMENT_OVERRIDE,
    SOURCING_EMAIL,
    CALL_SELLER,
    CALL_BUYER,
    CALL_RECORDING_DOWNLOAD,
    CALL_ANYONE,
    COMMISSION_PAYMENTS,
    SBR_ACCESS_TOKEN,
    EDIT_NEARBY_PROS_DATA,
    SAVE_SMS_IMAGE_TO_SBR,
    SHOW_HIDDEN_OUTGOING_SMS,
    SET_SBR_CONFIRMATION_PRICE,
    SHOW_IN_TRIAL_NEARBY_PROS_TAB,
    SHOW_COMMISSION_ONLY_NEARBY_PROS_TAB,
    SHOW_CANCELLED_NEARBY_PROS_TAB,
    SHOW_PAYMENT_PLANS,
    IMPERSONATE_SELLER,
    IMPERSONATE_BUYER,
    RADIUS_CHECK,
    ACTUAL_COMMISSION_REVENUE,
    SET_SELLER_PWD,
    SELLER_LIST_BY_ACCEPTING_JOB,
    SELLER_CATEGORY_RADIUS,
    SAAS_METRICS,
    LEAD_PAYMENT_FAILED
}
